export const about = `
## FurPortについて
FurPortはファーリーイベントに関する情報を整理・共有するサービスです。

るりいろ（lapi.gq）が個人で運営しております。問い合わせは下記までお願いします。

Twitter ID： @dragoneena12
`;
